var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", [_vm._v("Create your account")]),
    _vm._v(" "),
    _c(
      "p",
      {
        staticClass: "mt-3 font-sans-book text-lg",
        staticStyle: { "line-height": "1.75rem" },
      },
      [
        _vm._v(
          "\n    You’re about to join a community of people who are changing the world. By having a Reimagine account, you can add events to our platform, submit helpful resources to the community resource hub, and create a public profile so community members can find out about you, your offerings, and what you hope to reimagine.\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "spacer" }),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-col md:flex-row" }, [
      _c("div", { staticClass: "w-full md:pr-4" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'",
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.first_name,
              expression: "form.first_name",
            },
          ],
          staticClass: "w-full",
          attrs: { name: "first_name", type: "text" },
          domProps: { value: _vm.form.first_name },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.form, "first_name", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("first_name"),
                expression: "errors.has('first_name')",
              },
            ],
            staticClass: "error-message",
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.errors.first("first_name")) + "\n      "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spacer block md:hidden" }),
      _vm._v(" "),
      _c("div", { staticClass: "w-full" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'",
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.last_name,
              expression: "form.last_name",
            },
          ],
          staticClass: "w-full",
          attrs: { name: "last_name", type: "text" },
          domProps: { value: _vm.form.last_name },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.form, "last_name", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("last_name"),
                expression: "errors.has('last_name')",
              },
            ],
            staticClass: "error-message",
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.errors.first("last_name")) + "\n      "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "spacer" }),
    _vm._v(" "),
    _c("div", { staticClass: "w-full" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|email",
            expression: "'required|email'",
          },
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.email,
            expression: "form.email",
          },
        ],
        staticClass: "w-full",
        attrs: { name: "email", type: "email" },
        domProps: { value: _vm.form.email },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "email", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _vm.errors.has("email")
        ? _c(
            "div",
            { staticClass: "error-message" },
            [
              _vm.errors.first("email").includes("been taken")
                ? [
                    _vm._v(
                      "\n        An account already exists for this email address.\n        Click here to "
                    ),
                    _c(
                      "router-link",
                      { attrs: { to: { name: "user-login" } } },
                      [_vm._v("log in")]
                    ),
                    _vm._v("\n        or "),
                    _c(
                      "router-link",
                      { attrs: { to: { name: "user-forgot-password" } } },
                      [_vm._v("reset your password")]
                    ),
                    _vm._v(".\n      "),
                  ]
                : [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.errors.first("email")) +
                        "\n      "
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "spacer" }),
    _vm._v(" "),
    _c("div", { staticClass: "w-full" }, [
      _vm._m(3),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|min:8|upperCase|number|lowerCase",
            expression: "'required|min:8|upperCase|number|lowerCase'",
          },
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.password,
            expression: "form.password",
          },
        ],
        ref: "password",
        staticClass: "w-full",
        attrs: { name: "password", type: "password" },
        domProps: { value: _vm.form.password },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "password", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("password"),
              expression: "errors.has('password')",
            },
          ],
          staticClass: "error-message",
        },
        [_vm._v("\n      " + _vm._s(_vm.errors.first("password")) + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "spacer" }),
    _vm._v(" "),
    _c("div", { staticClass: "w-full" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|confirmed:password",
            expression: "'required|confirmed:password'",
          },
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.password_confirmation,
            expression: "form.password_confirmation",
          },
        ],
        staticClass: "w-full",
        attrs: { name: "password_confirmation", type: "password" },
        domProps: { value: _vm.form.password_confirmation },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "password_confirmation", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("password_confirmation"),
              expression: "errors.has('password_confirmation')",
            },
          ],
          staticClass: "error-message",
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.errors.first("password_confirmation")) +
              "\n    "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "spacer" }),
    _vm._v(" "),
    _c("label", [_vm._v("\n    Terms and conditions\n  ")]),
    _vm._v(" "),
    _c("div", { staticClass: "select-box" }, [
      _c("label", { staticClass: "w-full text-base font-normal" }, [
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'",
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.tos,
              expression: "form.tos",
            },
          ],
          attrs: { name: "tos", type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.form.tos)
              ? _vm._i(_vm.form.tos, null) > -1
              : _vm.form.tos,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.form.tos,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.form, "tos", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.form,
                      "tos",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.form, "tos", $$c)
              }
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "inline-block mr-2 check" }),
        _vm._v(" "),
        _vm._m(5),
      ]),
    ]),
    _vm._v(" "),
    _vm.errors.has("tos")
      ? _c("div", { staticClass: "block error-message" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.errors
                  .first("tos")
                  .replace(" tos ", " Terms of Service and Privacy agreement ")
              ) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "spacer" }),
    _vm._v(" "),
    _c("hr", { staticClass: "w-px bg-n-gray border border-n-gray w-full" }),
    _vm._v(" "),
    _c("div", { staticClass: "spacer" }),
    _vm._v(" "),
    _c("div", { staticClass: "flex justify-center" }, [
      _c(
        "button",
        { staticClass: "button", on: { click: _vm.createAccount } },
        [_vm._v("create my account")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "spacer" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n        First name "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n        Last name "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n      Email "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n      Password "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "block text-sm font-sans-book text-n-gray-dark mb-5" },
        [
          _vm._v(
            "\n        Should contain at least 8 characters, including at least 1 lowercase letter, 1 uppercase letter, and 1 number.\n      "
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n      Confirm password "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "font-normal font-sans-book" }, [
      _vm._v("\n        I agree to Reimagine's "),
      _c(
        "a",
        {
          attrs: {
            href: "https://letsreimagine.org/terms-conditions/",
            target: "_blank",
          },
        },
        [
          _c("span", { staticClass: "sr-only" }, [
            _vm._v("(opens in a new tab) "),
          ]),
          _vm._v("Terms of Service"),
        ]
      ),
      _vm._v(" and "),
      _c(
        "a",
        {
          attrs: {
            href: "https://letsreimagine.org/privacy-cookies/",
            target: "_blank",
          },
        },
        [
          _c("span", { staticClass: "sr-only" }, [
            _vm._v("(opens in a new tab) "),
          ]),
          _vm._v("Privacy Policy"),
        ]
      ),
      _vm._v(".\n      "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }